import {
  ScrollView,
  StyleSheet,
  Text,
  TouchableOpacity,
  View,
} from 'react-native';
import React, { FC, useMemo } from 'react';
import PageTitle from '../../components/PageTitle';
import { Footer } from '../../components/Footer';
import { Formik } from 'formik';
import { IFormData } from '../../components/FormHelper/FormHelper.types';
import { STYLE_VARS } from '../../constants/style-vars';
import DropDown from '../../components/DropDown/DropDown';
import { Button } from '../../components/Button';
import { DropDownItem } from '../../models/DropDownItem';
import { TextInput } from '../../components/TextInput/TextInput';
import DatePicker from './components/DatePicker';
import { useIsDesktop } from '../../hooks/useIsDeskTop';
import { ClubServiceLayout } from '../../WebLayout';
import { addBase64Prefix } from '../../services/addBase64Prefix';
import { IS_WEB } from '../../constants/platform';
import { reciprocal_clubs } from '../../assets/base64';
import SubmitForm from './components/SubmitForm';
import { FONTS } from '../../constants';

const ApplyReciprocalClub: FC = () => {
  const isDesktop = useIsDesktop();
  const initData = {
    country: '',
    clubs: [],
    visitPeriod: {
      from: '',
      to: '',
    },
    familyMembers: [],
  };
  const clubsData: DropDownItem[] = [
    {
      label: 'Athenaeum Club, Hobart',
      value: 'Athenaeum Club, Hobart',
    },
    {
      label: 'Box Hill Golf Club',
      value: 'Box Hill Golf Club',
    },
    {
      label: 'The Bentleigh Club',
      value: 'The Bentleigh Club',
    },
    {
      label: 'The C.T.A Business Club',
      value: 'The C.T.A Business Club',
    },
    {
      label: 'Canberra Southen Corss Club LTD',
      value: 'Canberra Southen Corss Club LTD',
    },
  ];
  const handleSubmit = (data: IFormData) => {};
  if (isDesktop()) {
    return (
      <ClubServiceLayout
        title="Reciprocal Clubs"
        icon={
          IS_WEB
            ? addBase64Prefix(reciprocal_clubs)
            : require('../../assets/reciprocal-clubs.png')
        }
        description="Please complete the form below at least 48 hours prior to your departure"
        current={3}
      >
        <SubmitForm
          clubsData={clubsData}
          handleSubmit={handleSubmit}
          initData={initData}
        />
      </ClubServiceLayout>
    );
  }

  return (
    <ScrollView showsVerticalScrollIndicator={false}>
      <View style={styles.container}>
        <PageTitle
          title="Reciprocal Clubs"
          icon={require('../../assets/reciprocal-clubs.png')}
          description="Please complete the form below at least 48 hours prior to your departure"
        />
      </View>
      <View style={styles.container}>
        <SubmitForm
          clubsData={clubsData}
          handleSubmit={handleSubmit}
          initData={initData}
        />
      </View>
      <Footer />
    </ScrollView>
  );
};

export default ApplyReciprocalClub;

const styles = StyleSheet.create({
  container: {
    paddingHorizontal: 20,
  },
  dropDownStyle: {
    borderColor: STYLE_VARS.fccDarkGrey,
    paddingHorizontal: 10,
  },
  headerDropdownText: {
    color: STYLE_VARS.textColor,
    textTransform: 'uppercase',
    fontFamily: STYLE_VARS.avenirMediumFont,
    fontSize: 13,
    fontWeight: '500',
  },
  input: {
    height: 43,
    paddingHorizontal: 10,
    alignItems: 'flex-start',
    paddingVertical: 10,
    borderWidth: 1,
    borderColor: STYLE_VARS.fccDarkGrey,
    color: STYLE_VARS.fccDarkerGrey,
    fontSize: 12,
    letterSpacing: 0.8,
    fontWeight: '500',
    fontFamily: FONTS.IowanOldStyleBTRoman,
    marginTop: 15,
  },
});
